<template>
  <div>
    <PageTitle
      title="Rooms"
      :btnCreate="true"
      :createRoute="'/room/add'"
      :permission="'Product Create'"
    />
    <v-container fluid class="lighten-12 content">
      <v-card class="lighten-12 card-content">
        <TableFilters
          :filters="[ 'search']"
          v-model="filter"
          :columns="columns"
        ></TableFilters>
      </v-card>

      <v-card class="mt-2">
        <v-container fluid>
          <v-row>
            <v-card-text class="pa-0">
              <v-data-table
                :items-per-page="paginationOptions.perPage"
                :fixed-header="true"
                :headers="headers"
                :items="rooms"
                item-key="id"
                hide-default-footer
              >
                <template v-slot:item.reference_number="{ item }">
                  <CopyTableCell :text="item.reference_number"></CopyTableCell>
                </template>
                <!-- No -->
                <template v-slot:item.no>
                  <v-icon>mdi-vuetify</v-icon>
                </template>
                <!-- Status -->
                <template v-slot:item.is_active="{ item }">
                  <v-chip
                    :x-small="true"
                    class="ma-2 cursor-pointer"
                    label
                    text-color="white"
                    :color="getStatusColor(item.is_active)"
                    dark
                    >{{ item.is_active}}</v-chip
                  >
                </template>

                <!-- Action -->
                <template v-slot:item.action="{ item }">
                  <list-menu
                    feature="room"
                    :item="item"
                    viewPermission="Room Show"
                    editPermission="Room Edit"
                    softDeletePermission="Product Soft"
                    DeletePermission="Room Edit"
                    @refreshList="refreshData"
                  ></list-menu>
                </template>

                <template v-slot:footer>
                  <pagination
                    @paginationOptions="setPaginationOptions"
                    @response="setResponseData"
                    url="hms/rooms"
                    :filter="filter"
                    ref="pagination"
                  />
                </template>
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>

      <div class="d-flex justify-center align-center"></div>
      <!-- </v-row> -->
    </v-container>
  </div>
</template>

<script>
// Components
import PageTitle from "@/components/shared/PageTitle";
import pagination from "../../shared/components/pagination";
import confirmation from "../../shared/components/confirmation";
import TableFilters from "@/components/base/TableFilters";

import { required, email, max } from "vee-validate/dist/rules";
import { mapGetters } from "vuex";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import BrandAutoComplete from "@/components/base/BrandAutoComplete";
import CategoryAutoComplete from "@/components/base/CategoryAutoComplete";
import StatusAutoComplete from "@/components/base/StatusAutoComplete";

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  data: () => ({
    paginationOptions: {},

    columns: [
      {
        text: "Reference Number",
        value: "reference_number",
        show: true,
        disabled: true,

        width: "14%",
      },
      {
        text: "Room Name",
        value: "name",
        align: "left",
        show: true,
        disabled: true,
        width: "14%",
      },
      {
        text: "Floor",
        value: "floor.name",
        show: true,
        align: "left",
        disabled: false,
        width: "14%",
      },
      {
        text: "Phone Number",
        value: "phone_expression",
        show: true,
        align: "left",
        disabled: false,
        width: "14%",
      },
    
      // {
      //   text: "Status",
      //   value: "is_active",
      //   show: true,
      //   disabled: false,
      //   align: "center",
      //   width: "14%",
      // },
      {
        text: "Actions",
        value: "action",
        show: true,
        disabled: false,
        align: "center",
        width: "14%",
      },
    ],
    rooms: [],
    // Filters
    filter: {
      category: "",
      search: "",
      brand: "",
      status: "",
    },
  }),
  components: {
    PageTitle,
    ValidationProvider,
    ValidationObserver,
    pagination,
    TableFilters,
  },

  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },

    setResponseData(rooms) {
      
      this.rooms = rooms;
      this.rooms.map((u) => {
        if (u.image) {
          u.image = u.image + "?t=" + new Date().getTime();
        }
      });
    },
    clearFilter() {
      this.filter = {};
    },
    getStatusColor(is_active) {
      return is_active ? "green" : "gray";
    },

    EditModal(item) {
      this.$router.push({ path: "/product/edit/" + item.id });
    },
  },
  computed: {
    ...mapGetters("product", ["GetAllProducts"]),
    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
};
</script>
